import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../Styles/SettingsComponent.module.css";

const SettingsComponent = ({ icon, title, link, disabled }) => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        if (!disabled) {
            navigate(link);
        }
    };

    return (
        <div className={`${styles.card} ${disabled ? styles.disabledCard : ""}`}>
            <div className={styles.icon}>{icon}</div>
            <h3 className={styles.title}>{title}</h3>
            <button
                className={`${styles.button} ${disabled ? styles.disabledButton : ""}`}
                onClick={handleNavigate}
                disabled={disabled} // Disable button if the card is disabled
            >
                Avaa
            </button>
        </div>
    );
};

export default SettingsComponent;